import { useId, useState } from "react";
import PropTypes from "prop-types";
import PartnershipForm from "./Form";

const DEFAULTS = {
  heading: "Ready to Partner With Outskill?",
  description:
    "Join 1500+ creators already shaping the future of learning. Grow your platform, unlock exclusive perks, and gift your audience world-class AI education.",
  ctaLabel: "Apply to Partner Now",
  email: "partnerwithus@outskill.com",
  bgMobile: "/partnerships/partmob.webp",
  bgDesktop: "/partnerships/partdesk.webp",
};

const PartnerCTA = ({
  heading = DEFAULTS.heading,
  description = DEFAULTS.description,
  ctaLabel = DEFAULTS.ctaLabel,
  email = DEFAULTS.email,
  bgMobile = DEFAULTS.bgMobile,
  bgDesktop = DEFAULTS.bgDesktop,
  onCtaClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const reactId = useId();
  const bgClass = `partner-cta-bg-${reactId.replace(/:/g, "")}`;

  const handleClick = () => {
    if (onCtaClick) {
      onCtaClick();
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div
      className="w-full bg-white font-fira-sans"
      style={{
        backgroundImage: `url(${bgMobile})`,
      }}
    >
      <style>{`@media (min-width: 768px){.${bgClass}{background-image:url(${bgDesktop}) !important;}}`}</style>
      <div className={bgClass}>
        <div
          className="w-[90%] md:w-auto mx-auto md:mx-[153px]"
          style={{
            borderLeft: "1px solid rgba(255, 255, 255, 0.20)",
            borderRight: "1px solid rgba(255, 255, 255, 0.20)",
          }}
        >
          <div className="px-4 py-10 md:px-0 md:py-14 md:pl-[60px] md:pr-[60px]">
            <div className="flex w-full min-h-[400px] flex-col items-start justify-center rounded-[2px]  bg-cover bg-center bg-no-repeat p-2 md:min-h-[300px] md:flex-col md:justify-center  md:p-8">
              <div className="w-full md:max-w-2xl">
                <h2 className="mb-4 text-2xl font-medium text-white md:mb-6 md:text-[32px]">
                  {heading}
                </h2>

                <p className="mb-auto text-base font-normal leading-relaxed text-gray-300 md:mb-8 md:text-lg">
                  {description}
                </p>
              </div>

              <div className="flex-1 md:hidden" />

              <div className="mt-auto flex w-full flex-col md:mt-0 md:w-auto md:flex-row md:items-center">
                <button
                  type="button"
                  onClick={handleClick}
                  className="mb-4 inline-block w-full cursor-pointer rounded-[2px] bg-[#B8EF43] px-8 py-2 text-center text-base font-medium text-black transition-all duration-300 hover:bg-lime-300 md:mb-0 md:mr-4 md:w-auto md:text-lg"
                >
                  {ctaLabel}
                </button>

                <div className="mt-6 hidden items-center gap-3 md:mt-0 md:flex">
                  <div className="h-12 w-px bg-gray-600" />
                  <div className="text-sm text-gray-400">
                    Reach us out at{" "}
                    <a
                      href={`mailto:${email}`}
                      className="text-gray-300 underline transition-colors hover:text-white"
                    >
                      {email}
                    </a>
                    <br />
                    to get in touch for any queries.
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center text-sm text-gray-400 md:hidden">
                Reach us out at{" "}
                <a
                  href={`mailto:${email}`}
                  className="text-gray-300 underline"
                >
                  {email}
                </a>{" "}
                to get in touch / any queries.
              </div>
            </div>
          </div>
        </div>
      </div>

      {!onCtaClick && isOpen && (
        <PartnershipForm onClose={() => setIsOpen(false)} />
      )}
    </div>
  );
};

PartnerCTA.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  ctaLabel: PropTypes.string,
  email: PropTypes.string,
  bgMobile: PropTypes.string,
  bgDesktop: PropTypes.string,
  onCtaClick: PropTypes.func,
};

export default PartnerCTA;
